// hooks/useKeyboard.js
import { useEffect } from 'react'

/**
 * Hook pour gérer les raccourcis clavier
 * @param {Object} shortcuts - Map de key -> handler
 * @param {Array} deps - Dépendances
 */
export function useKeyboard(shortcuts, deps = []) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore si focus dans input/textarea
      const target = e.target
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return
      }

      const handler = shortcuts[e.key]
      if (handler) {
        e.preventDefault()
        handler(e)
      }

      // Gestion des combinaisons (Cmd/Ctrl + key)
      if ((e.metaKey || e.ctrlKey) && shortcuts[`${e.ctrlKey ? 'Ctrl' : 'Cmd'}+${e.key}`]) {
        e.preventDefault()
        shortcuts[`${e.ctrlKey ? 'Ctrl' : 'Cmd'}+${e.key}`](e)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [shortcuts, ...deps])
}
